import React from "react"
import Footer from "../components/footer"
import Navigation from "../components/navigation"
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import SEO from "../components/seo"
import PostLink from "../components/post-link"
import { graphql } from "gatsby"



const Product = ({data: {allMarkdownRemark:{ edges },},}) => {
  const Posts = edges
          .filter(edge => !!edge.node.frontmatter.date) // You can filter your posts based on some criteria
          .map(edge => <PostLink key={edge.node.id} post={edge.node} />)
  
          return (
      <div>
        <SEO title="Product"  />
        <Navigation />
        <Container>
          <Row className='m-2 mb-4'>
            <Col className='pb-3 mb-5'>
              <h1 className='pb-4 mb-5'>
            Product.
            </h1>
            <h6 className='mb-4'> When we are building a digital product, what aspects of the human experience are we trying to encourage or discourage? How do we get the right balance or mix of it? </h6>
            <h6> I don't start my product planning with ideas or roadmaps. I start with people and personas. Understanding people and their conditions are how I know what I want to encourage, reveal or augment in my product</h6>
          </Col>
          </Row>
          </Container>
          <Container>
          <div>
            
            {Posts}
            </div>
            
            
          </Container>

        <Footer />
      </div>
)
}

export default Product


export const pageQuery = graphql`
  query {
    allMarkdownRemark(
      sort: { order: DESC, fields: [frontmatter___date] }
      filter: { frontmatter: {category: {eq: "product"}}}
      
      ) {
      edges {
        node {
          id
          frontmatter {
            date(formatString: "MMMM DD, YYYY")
            slug
            title
            featuredImage{
              childImageSharp{
                fluid(maxWidth:1200){
                  ...GatsbyImageSharpFluid
                }
              }
            }
          }
        }
      }
    }
  }
`

// Visit here for details https://www.gatsbyjs.com/docs/adding-a-list-of-markdown-blog-posts/